/**
 * Managers can expose their APIs, so Interactors can communicate with them
 */
export class WithApi<T extends object> {
  private api: T | null = null;

  private apiReadyPromise: Promise<T>;

  private resolveApi!: (api: T) => void;

  constructor() {
    this.apiReadyPromise = new Promise<T>((resolve) => {
      this.resolveApi = resolve;
    });
  }

  public isInited() {
    return !!this.api;
  }

  /**
   * @deprecated use `getApiWhenReady` instead
   */
  public getApi() {
    if (!this.api) {
      throw new Error('APIs cannot be accessed before the manager is initialized.');
    }

    return this.api;
  }

  public async getApiWhenReady(): Promise<T> {
    return this.api || this.apiReadyPromise;
  }

  protected initApi(api: T) {
    this.api = api;

    this.resolveApi(this.api); // Resolve the promise when API is initialized
  }
}
